import React, {useEffect, useLayoutEffect, useState} from 'react';
import styled from 'styled-components';
import {Contents, DropdownMenu, Overlay} from "../../../components";
import {useRecoilState, useRecoilValue} from "recoil";
import {subMenuState, userInfo} from "../../../../state";
import {SpacingV} from "../../InstructorApp/component/common/Spacing";
import {constCommon} from "../../../../constants";
import {AddChapter, Col, FormBox, ProfileFormBoxItemWrap, FormItem, Row} from "../../../../styled/StyledComponent";
import PlusIcon from "../../../../assets/images/icon/PlusIcon";
import AutoComplete from "../../InstructorApp/component/common/AutoComplete";
import DateIcon from "../../../../assets/images/icon/DateIcon";
import DeleteIcon from "../../../../assets/images/icon/DeleteIcon";
import RemoveGrey from "../../../../assets/images/icon/RemoveGrey";
import EditIcon from "../../../../assets/images/icon/EditIcon";
import EditIdPopup from "../components/EditIdPopup";
import {teachersAPI} from "../../../../api/teachersAPI";
import EditPasswordPopup from "../components/EditPasswordPopup";

const AccountSettiong = () => {
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    const [info, setInfo] = useState(null);
    const [idPopup, setIdPopup] = useState(false);
    const [pwPopup, setPwPopup] = useState(false)
    const [toast, setToast] = useState(false);

    const getProfile = async () => {
        await teachersAPI.getTeacherProfile()
            .then(res => {
                console.log("@user",res);
                setInfo(res?.data)
            })
    };
    const toastPopup = () => {
        setToast(true)
        setTimeout(()=>{
            setToast(false)
        },3000)
    }

    useLayoutEffect(() => {
        getProfile()
    }, []);
    return(
        <Container>
            <Contents title={subMenu}>
                <ContentsInner>
                    <ProfileHeader>
                        <Thumb className={"mobile"}>
                            <Img>
                                <img src={"/images/account.png"} />
                            </Img>
                        </Thumb>
                        <HeaderContents>
                            <Row className={"account"} display={"flex"} style={{width: "100%", alignItems:"center"}}>
                                <Col style={{width: "100%",}}>
                                    <FormBox>
                                        <dt>
                                            Email
                                        </dt>
                                        <dd>
                                            <ProfileFormBoxItemWrap>
                                                <li>
                                                    <FormItem>
                                                        <input
                                                            disabled={true}
                                                            value={info?.email}
                                                            type="text" placeholder={"Email"}/>
                                                    </FormItem>
                                                </li>
                                            </ProfileFormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                                <Col style={{width:22, minWidth:22}}>
                                    <FormBox>
                                        <dt style={{pointerEvents: "none"}}>
                                            &nbsp;
                                        </dt>
                                        <dd>
                                            <ProfileFormBoxItemWrap>
                                                <li>
                                                    <FormItem
                                                        onClick={()=>{setIdPopup(v => !v)}}
                                                        className={"edit"}>
                                                        <EditIcon/>
                                                        <span>Edit</span>
                                                    </FormItem>
                                                </li>
                                            </ProfileFormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                            </Row>
                            <Row  className={"account"}  display={"flex"} style={{width: "100%", marginBottom: 0, paddingBottom: 0}}>
                                <Col style={{width: "100%", marginBottom:0, paddingBottom:0}}>
                                    <FormBox>
                                        <dt>
                                            Password
                                        </dt>
                                        <dd>
                                            <ProfileFormBoxItemWrap style={{marginBottom:0}}>
                                                <li>
                                                    <FormItem>
                                                        <input value={"********"} disabled={true} type="password" placeholder={"Password"}/>
                                                    </FormItem>
                                                </li>
                                            </ProfileFormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                                <Col style={{width:22, minWidth:22}}>
                                    <FormBox>
                                        <dt style={{pointerEvents:"none"}}>
                                            &nbsp;
                                        </dt>
                                        <dd>
                                            <ProfileFormBoxItemWrap>
                                                <li>
                                                    <FormItem
                                                        onClick={()=>{setPwPopup(v => !v)}}
                                                        className={"edit"}>
                                                        <EditIcon/>
                                                        <span>Edit</span>
                                                    </FormItem>
                                                </li>
                                            </ProfileFormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                            </Row>
                        </HeaderContents>
                        <Thumb className={"wide"}>
                            <Img>
                                <img src={"/images/account.png"} />
                            </Img>
                        </Thumb>
                    </ProfileHeader>
                </ContentsInner>
            </Contents>

            <SpacingV height={63} />
            {
                idPopup &&
                <Overlay filter={true}>
                    <EditIdPopup getProfile={getProfile}
                                 onToastPopup={toastPopup}
                                 onClickPopup={()=>{setIdPopup(v => !v)}} />
                </Overlay>

            }
            {

                pwPopup &&
                <Overlay filter={true}>
                <EditPasswordPopup getProfile={getProfile}
                                        onToastPopup={toastPopup}
                                        onClickPopup={()=>{setPwPopup(v => !v)}} />
                </Overlay>
            }
            <Toast className={toast ? "on" : ""}>
                <p>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                            fill="#11A761"/>
                    </svg>
                    &nbsp;Account setting has been updated successfully
                </p>

                <svg onClick={(e)=>{
                    e.stopPropagation();
                    setToast(false)
                }} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.146447 0.853554C-0.0488156 0.658291 -0.0488156 0.341709 0.146447 0.146447C0.341709 -0.0488155 0.658292 -0.0488155 0.853554 0.146447L6 5.29289L11.1464 0.146447C11.3417 -0.0488155 11.6583 -0.0488155 11.8536 0.146447C12.0488 0.341709 12.0488 0.658291 11.8536 0.853554L6.70711 6L11.8536 11.1464C12.0488 11.3417 12.0488 11.6583 11.8536 11.8536C11.6583 12.0488 11.3417 12.0488 11.1464 11.8536L6 6.70711L0.853554 11.8536C0.658292 12.0488 0.341709 12.0488 0.146447 11.8536C-0.048815 11.6583 -0.048815 11.3417 0.146447 11.1464L5.29289 6L0.146447 0.853554Z"
                        fill="#333333"/>
                </svg>
            </Toast>
        </Container>
    )

}
export default AccountSettiong;

const Container = styled.div`

`;
const ContentsInner = styled.div`
    padding: 20px 0px;

    h1 {
        font-family: Europa-Bold;
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #DDC160;
    }
`
const ProfileHeader = styled.div`
    display: flex;
    padding: 0 20px;
    width: 100%;
    @media screen and (max-width: 768px) {
        flex-direction: column!important;
    }
    input {
        width: 100%;
    }
`
const ContentBox = styled.div`
    padding: 0 20px;
`
const Thumb = styled.div`
    margin-left: 97px;
    &.mobile{
        display: none;
        margin-left: 0;
        align-items: center;
        justify-content:center;
        @media screen and (max-width: 768px) {
            display: flex;
        }
    }
    &.wide{
        @media screen and (max-width: 768px) {
            display: none;
        } 
    }
    > dt {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        opacity: 0.8;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`
const Img = styled.div`
   width: 222px;
   height: 200px;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`
const HeaderContents = styled.div`
   width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px 0;
    .edit{
        cursor: pointer;
        margin-top: 14px;
        margin-left: 10px;
        font-family: Europa-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 10px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        display: flex;
        flex-direction: column;
        span{
            margin-top: 8px;
        }
    }
`
const Toast = styled.div`
    transition: all 0.3s;
    &.on{
        opacity: 1;
        pointer-events: all;
    }
    opacity: 0;
    pointer-events: none;
    left: 30%;
    top: 9%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
        display: flex;
        align-items: center;
        svg{
            margin-bottom: 2px;
        }
    }
    svg{
        cursor: pointer;
    }
    width: 650px;
    position: fixed;
    z-index: 9999;
    font-family: Europa-Bold;
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: left;
    color: #11A761;
    box-shadow: 0px 6px 10px 0px #11A76124;
    border: 2px solid #11A761;
    background: #E3FBF4;
    border-radius: 10px;
    padding: 22.5px;
`